import React from "react"

import WhatsappConnectionFlow from "@/@integrations/Whatsapp/components/WhatsappConnectionFlow"
import WABAConnectionFlow from "@/@integrations/WABA/components/WABAConnectionFlow"
import { useGlobalStateStore } from "@/store/GlobalState"

import { Grid, Link as LinkMUI, Typography } from "@material-ui/core"
import { WarningTwoTone as WarningIcon } from "@material-ui/icons"
import { isAbleToValidateEmail } from "@/utils/time"
import { IChannel } from "@/protocols/channel"

import AlertContainer from "@/components/AlertContainer"
import Metrics from "@/pages/Admin/Dashboard/Metrics"
import Banners from "@/pages/Admin/Dashboard/Banners"

import DateService from "@/services/Date"
import * as dateFns from "date-fns"

import { colors } from "@/styles/colors"

const LIMIT_OF_DAYS_WITHOUT_CONNECTION = 3

const Dashboard: React.FC = () => {
	const globalStateStore = useGlobalStateStore()

	const canValidateEmail = isAbleToValidateEmail()
	const currentChannel = globalStateStore.currentChannel as IChannel
	const isWabaChannel = currentChannel?.channelType === "waba"

	const showAlertForDaysWithoutConnection = React.useMemo(() => {
		if (currentChannel?.syncControlData) {
			const currentDate = DateService.currentWorldDate()
			const lastConnection = new Date(currentChannel.syncControlData.last_authentication_successful_date)

			const differenceInDays = dateFns.differenceInDays(currentDate, lastConnection)

			return differenceInDays > LIMIT_OF_DAYS_WITHOUT_CONNECTION
		}
		return false
	}, [currentChannel])

	return (
		<Grid id="dashboard-container" container direction="column" spacing={8}>
			<Grid item>
				<Grid container direction="column" spacing={4}>
					<Grid item>
						<Grid container direction="column" spacing={1}>
							{canValidateEmail && (
								<Grid item xs={12}>
									<AlertContainer
										title="ATENÇÃO"
										alertType="warning"
										icon={<WarningIcon htmlColor={colors.yellow[500]} fontSize="large" />}
									>
										<Typography variant="body2">
											Seu e-mail não está verificado. Ajude a proteger sua conta contra o acesso não autorizado.{" "}
											<LinkMUI
												href={"/admin/profile"}
												target="_self"
												underline="always"
												style={{ textDecoration: "none" }}
											>
												Validar email
											</LinkMUI>
										</Typography>
									</AlertContainer>
								</Grid>
							)}

							{(!isWabaChannel && showAlertForDaysWithoutConnection) && (
								<Grid item xs={12}>
									<AlertContainer
										title="Você está há mais de 3 dias sem fazer uma nova conexão."
										alertType="warning"
										icon={<WarningIcon htmlColor={colors.yellow[500]} fontSize="large" />}
									>
										<Typography variant="body2">
											Ficar muitos dias sem fazer uma nova conexão pode trazer alguns problemas, como: falha no envio e no recebimento de mensagens, mensagens que não foram sincronizadas, mensagens duplicadas, entre outros.{" "}
										</Typography>
									</AlertContainer>
								</Grid>
							)}

							{globalStateStore.currentChannel?.channelType === "whatsapp" && (
								<Grid item>
									<WhatsappConnectionFlow />
								</Grid>
							)}

							{globalStateStore.currentChannel?.channelType === "waba" && (
								<Grid item>
									<WABAConnectionFlow />
								</Grid>
							)}
						</Grid>
					</Grid>

					<Grid item>
						<Banners />
					</Grid>
				</Grid>
			</Grid>

			<Grid item>
				<Metrics />
			</Grid>
		</Grid>
	)
}

export default Dashboard
